export default __webpack_public_path__ + "static/media/ENERGIA.65a9df23.png";